import { toNumberWithFallback } from "features/shared/lib/formatters";

import type {
  DayNightFlushingConfig,
  TechnicalDataScenario,
  TechnicalDataScenarioFormState,
  TrScenarioCreatePayload,
} from "../model/types";

export const DEFAULT_SCENARIO_METRICS = {
  heatRecoveryEff: 0.8,
  internalLoads: 1,
  occupancy: 1,
} as const;

export const DEFAULT_REQUIRED_TEMPERATURES = {
  requiredTMax: 28,
  requiredTMin: 26,
} as const;

export const DEFAULT_DAY_NIGHT_FLUSHING: DayNightFlushingConfig | null = null;

export const isDefaultScenario = (scenario: TechnicalDataScenario) => scenario.isDefault;

export const createEmptyScenarioFormState = (): TechnicalDataScenarioFormState => ({
  heatRecoveryEff: String(DEFAULT_SCENARIO_METRICS.heatRecoveryEff),
  internalLoads: String(DEFAULT_SCENARIO_METRICS.internalLoads),
  name: "",
  occupancy: String(DEFAULT_SCENARIO_METRICS.occupancy),
});

export const mapScenarioToFormState = (scenario: TechnicalDataScenario): TechnicalDataScenarioFormState => ({
  heatRecoveryEff: String(scenario.heatRecoveryEff),
  internalLoads: String(scenario.internalLoads),
  name: scenario.name,
  occupancy: String(scenario.occupancy),
});

export const mapFormStateToScenarioMetricsPayload = (
  formState: TechnicalDataScenarioFormState
): Pick<
  TrScenarioCreatePayload,
  "dayNightFlushing" | "heat_recovery_eff" | "internal_loads" | "name" | "occupancy"
> => ({
  dayNightFlushing: DEFAULT_DAY_NIGHT_FLUSHING,
  heat_recovery_eff: toNumberWithFallback(formState.heatRecoveryEff, DEFAULT_SCENARIO_METRICS.heatRecoveryEff),
  internal_loads: toNumberWithFallback(formState.internalLoads, DEFAULT_SCENARIO_METRICS.internalLoads),
  name: formState.name.trim(),
  occupancy: toNumberWithFallback(formState.occupancy, DEFAULT_SCENARIO_METRICS.occupancy),
});
